import { containerNames } from '../../constants';
import { PixiBase } from '../../core/pixi/PixiBase';
import { winBarStore } from '../../store/winBarStore';
import { Spine } from '../../services/elementTypeService/Spine';
import { addToGameTimer, removeFromGameTimer } from '../../lib/timer';
import { gameMainDrawer } from './gameMainDrawer';
import { isMobile } from '../../helpers/isMobile';
import { soundService } from '../../services';
import { SoundTypes } from '../../services/baseSoundService/soundService';
import { spinBarStore } from '../../store/spinBarStore';
import { gameStore } from '../../store/gameStore';

export class ExpandWeedDrawer {
  constructor() {
    this.animations = {};
    this.ExpandWildBarContainer = PixiBase.createContainer(containerNames.ExpandWildBarContainer);
    this.isEndWildContainerMove = false;
    this.reelBoardBottomPosition = isMobile() ? 605 : 703;
    this.reelBoardTopPosition = isMobile() ? 300 : 194;
    this.isWildOpened = false;
  }

  setupWildInColumn() {
    this.wildReelsContainer = PixiBase.createContainer(containerNames.WildReelsContainer);
    const { x, y } = this.config.ExpandWildBarContainer;
    PixiBase.setPosition(this.ExpandWildBarContainer, { x: x, y: y });
    for (let i = 0; i < 5; i += 1) {
      const wild = new Spine({ key: '9' });
      wild.play('idle');
      wild.reelIndex = i;
      PixiBase.setPosition(wild, { x: i * (isMobile() ? 106 : 180) });
      this.wildReelsContainer.addChild(wild);
      wild.visible = false;
      this.wild = wild;
    }
    this.wildReelsContainer.children.reverse();
    this.ExpandWildBarContainer.addChild(this.wildReelsContainer);
    this.ExpandWildBarContainer = PixiBase.setMaskGraphicToContainer(
      this.ExpandWildBarContainer,
      gameMainDrawer.slotBar.columnsMaskGraphics
    );
  }

  updateWildYAndPlayExpandAnimation() {
    removeFromGameTimer(this.symbolHideTime);
    this.expandIndexArr = winBarStore.expandingWildData?.reduce((acc, curr, index) => {
      if (curr) {
        acc.push(index);
      }
      return acc;
    }, []);
    return new Promise((resolve) => {
      winBarStore.winBarSymbolsById.forEach((reel) => {
        if (this.expandIndexArr?.includes(reel.index)) {
          reel._finalDrawIcons.forEach((symbol) => {
            this.symbolHideTime = addToGameTimer(400, () => {
              symbol.alpha = 0;
            });
            if (symbol.iconNumber === 9) {
              const index = reel.index === 1 ? 3 : reel.index === 3 ? 1 : reel.index;
              soundService.play(SoundTypes.WildOpeningSound);
              gameMainDrawer.spinBar.winClick = true;
              this.wildReelsContainer.children[index].y = symbol.y;
              this.wildReelsContainer.children[index].visible = true;
              this.wildReelsContainer.children[index].clearListeners();
              if (symbol.y < (isMobile() ? 75 : 125.5)) {
                this.wildReelsContainer.children[index].play('wild1', false, 1.1);
                this.wildReelsContainer.children[index].addListener(
                  'complete',
                  () => {
                    this.isWildOpened = true;
                    gameMainDrawer.spinBar.winClick = false;
                    spinBarStore.setIsSpinStart(false);
                    resolve();
                    this.wildReelsContainer.children[index].play('idleBig1', true);
                  },
                  this,
                  'wild1'
                );
              } else if (symbol.y < (isMobile() ? 150 : 255)) {
                this.wildReelsContainer.children[index].play('wild2', false, 1.1);
                this.wildReelsContainer.children[index].addListener(
                  'complete',
                  () => {
                    this.isWildOpened = true;
                    gameMainDrawer.spinBar.winClick = false;
                    spinBarStore.setIsSpinStart(false);
                    resolve();
                    this.wildReelsContainer.children[index].play('idleBig2', true);
                  },
                  this,
                  'wild2'
                );
              } else if (symbol.y < (isMobile() ? 225 : 382.5)) {
                this.wildReelsContainer.children[index].play('wild3', false, 1.1);
                this.wildReelsContainer.children[index].addListener(
                  'complete',
                  () => {
                    this.isWildOpened = true;
                    gameMainDrawer.spinBar.winClick = false;
                    spinBarStore.setIsSpinStart(false);
                    resolve();
                    this.wildReelsContainer.children[index].play('idleBig3', true);
                  },
                  this,
                  'wild3'
                );
              } else {
                this.wildReelsContainer.children[index].play('wild4', false, 1.1);
                this.wildReelsContainer.children[index].addListener(
                  'complete',
                  () => {
                    this.isWildOpened = true;
                    gameMainDrawer.spinBar.winClick = false;
                    spinBarStore.setIsSpinStart(false);
                    resolve();
                    this.wildReelsContainer.children[index].play('idleBig4', true);
                  },
                  this,
                  'wild4'
                );
              }
            }
          });
        } else if (winBarStore.expandingWildData?.every((el) => !el)) {
          resolve();
        }
      });
    });
  }

  moveWildContainer() {
    this.ExpandWildBarContainer.y += gameStore.reelSpeed;
  }

  initializeExpandWildBarContainerPosition() {
    this.wildReelsContainer.children.forEach((reel) => {
      reel.visible = false;
    });
    this.ExpandWildBarContainer.y = this.reelBoardTopPosition;
    this.isWildOpened = false;
  }

  execute(config, spriteSheet) {
    const [gameImageSpriteSheet] = spriteSheet;
    this.config = config;
    this.spriteSheet = gameImageSpriteSheet;
    this.setupWildInColumn();
  }
}
